import { useNavigate } from 'react-router-dom'
import { Table, Input } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'

export default function PeriodBasedReportForm({ location }) {
  console.log('PeriodBasedReportForm rendered: ', location)

  let init = {
    dateFrom: '',
    dateTo: '',
    includeNullDates: 'on',
    procedureName: 'period_based_report'
  }

  const navigate = useNavigate()
  init = initialFormValues('PeriodBasedReportForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    console.log('PeriodBasedReportForm.submitSearch', inputs)
    inputs.includeNullDates = (inputs.includeNullDates === 'on' || inputs.includeNullDates === 'Y') ? 'Y' : 'N'
    submitFormValues('PeriodBasedReportForm', navigate, inputs, 'period_based_report.period_based_report')
  }

  if(inputs.includeNullDates === 'N') {
    inputs.includeNullDates = ''
  }
  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{backgroundColor: 'white'}}>
            <FormHeading headingText='Period Based Report' />
            <tbody>
              <tr>
                <td style={{verticalAlign: 'middle'}} ><b>Date Range</b></td>
                <td>
                  <div><b>From</b><Input className="custom-input" type='date' name='dateFrom' onChange={handleInputChange} defaultValue={inputs.dateFrom} />
                    <b>To</b><Input className="custom-input" type='date' name='dateTo' onChange={handleInputChange} defaultValue={inputs.dateTo} /></div>
                  <Input className="custom-checkbox" type="checkbox" defaultChecked={inputs.includeNullDates} name="includeNullDates" onChange={handleInputChange} /> Include records where Date Assigned is not specified<span><br /></span>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label="Run Report" />
      </form>
    </div>
  )
}

